import { IconButton } from "@shared/components/icon-button";
import { ICON_SIZE } from "@shared/components/icon-button/types";
import Bookmark from "@svg/new-design/bookmark";
import BookmarkBold from "@svg/new-design/bookmark-bold";
import ShareIcon from "@svg/new-design/share";
import TrafficIcon from "@svg/new-design/traffic";
import { SITE_URL } from "@utils/constants";
import classNames from "classnames";

interface Props {
  favoriteLoading: boolean;
  is_favorite: boolean;
  setFavoriteAction: () => void;
  copyCourseLink: () => void;
  slug: string;
}
const LayoutAction = ({
  favoriteLoading,
  is_favorite,
  setFavoriteAction,
  copyCourseLink,
  slug,
}: Props) => {
  const handleShareLink = async () => {
    await navigator.clipboard.writeText(`${SITE_URL}/courses/${slug}`);
    copyCourseLink();
  };
  return (
    <div className="flex items-center  lg:hidden  gap-1">
      <div className="cursor-pointer" onClick={handleShareLink}>
        <IconButton
          icon={<ShareIcon />}
          iconClassName="text-fds-icon-secondary"
          size={ICON_SIZE.MEDIUM}
          aria-label="اشتراک گذاری"
        />
      </div>
      <IconButton
        icon={
          favoriteLoading ? (
            <TrafficIcon />
          ) : is_favorite ? (
            <BookmarkBold />
          ) : (
            <Bookmark />
          )
        }
        iconClassName={classNames(
          "text-fds-icon-secondary",
          favoriteLoading && "animate-spin"
        )}
        size={ICON_SIZE.MEDIUM}
        onClick={() => setFavoriteAction()}
        aria-label={is_favorite ? "حذف از علاقه‌مندی" : "افزودن به علاقه‌مندی"}
      />
    </div>
  );
};

export default LayoutAction;
